import { request } from 'api/request';

import { getProjectNameHeader } from 'hooks/permission/utils';

import type { ERROR_DATA } from '../type';
import { useMutation } from '@tanstack/react-query';

interface MutateProps {
    userId: string;
    projectId?: number;
    body: {
        groups: string[];
    };
}

const apiRequest = async (payload: MutateProps) => {
    return await request(`admin/users/${payload.userId}`, {
        method: 'PUT',
        body: JSON.stringify(payload.body),
        headers: getProjectNameHeader(payload.projectId),
    });
};

export const usePutUser = () => {
    return useMutation<unknown, ERROR_DATA<unknown>, MutateProps>({
        mutationFn: (payload) => apiRequest(payload),
    });
};
